export const AddressIconUnselected = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_1025_4059)">
        <path
          d="M13.3334 6.40588C13.3334 8.31736 11.3938 11.1701 9.85394 13.1337C9.05058 14.1582 8.6489 14.6704 8.00008 14.6704C7.35126 14.6704 6.94958 14.1582 6.14622 13.1337C4.60638 11.1701 2.66675 8.31736 2.66675 6.40588C2.66675 3.23624 5.05456 0.666748 8.00008 0.666748C10.9456 0.666748 13.3334 3.23624 13.3334 6.40588Z"
          stroke="#AEAFC7"
          strokeWidth="1.5"
        />
        <path
          d="M6.00008 6.66675C6.00008 7.77132 6.89551 8.66675 8.00008 8.66675C9.10465 8.66675 10.0001 7.77132 10.0001 6.66675C10.0001 5.56218 9.10465 4.66675 8.00008 4.66675C6.89551 4.66675 6.00008 5.56218 6.00008 6.66675Z"
          stroke="#AEAFC7"
          strokeWidth="1.5"
        />
        <path
          d="M9.5 6.66675C9.5 7.49518 8.82843 8.16675 8 8.16675C7.17157 8.16675 6.5 7.49518 6.5 6.66675C6.5 5.83832 7.17157 5.16675 8 5.16675C8.82843 5.16675 9.5 5.83832 9.5 6.66675Z"
          fill="white"
          stroke="#AEAFC7"
        />
      </g>
      <defs>
        <clipPath id="clip0_1025_4059">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
